import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import BackLink from "components/front-layout/back-link"
import currentDate from "shared/current-date"
import memo from "set-state-compare/build/memo"
import moment from "shared/moment"
import MoodBarChartSlide from "components/user/school-classes/insights/mood-bar-chart-slide"
import MoodChartSlide from "components/user/school-classes/insights/mood-chart-slide"
import Params from "@kaspernj/api-maker/build/params"
import Routes from "shared/routes"
import {SchoolClass} from "models"
import ScoreFactorChartSlide from "components/user/school-classes/insights/score-factor-chart-slide"
import setLayout from "shared/set-layout"
import Slide from "components/slider/slide"
import Slider from "components/slider"
import TextComponentReplace from "shared/text-component-replace"
import {useFrontLayout} from "components/front-layout"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import useModel from "@kaspernj/api-maker/build/use-model"
import {useParams} from "@kaspernj/api-maker/build/router/route"
import useQueryParams from "on-location-changed/build/use-query-params"
import {View} from "react-native"

/** @typedef {object} RoutesUserSchoolClassesInsightsProps */

/**
 * @typedef {object} RoutesUserSchoolClassesInsightsState
 * @property {boolean} slide1loaded
 * @property {boolean} slide2loaded
 * @property {boolean} slide3loaded
 */

/**
 * @extends {ShapeComponent<RoutesUserSchoolClassesInsightsProps, RoutesUserSchoolClassesInsightsState>}
 */
class RoutesUserSchoolClassesInsights extends ShapeComponent {
  /** @type {RoutesUserSchoolClassesInsightsState} */
  state = {
    slide1loaded: false,
    slide2loaded: false,
    slide3loaded: false
  }

  setup() {
    setLayout("user")

    const {t} = useI18n({namespace: "js.routes.user.school_classes.insights"})
    const params = useParams()
    const {schoolClass, schoolClassId, schoolClassNotFound} = useModel(SchoolClass, {
      abilities: {
        SchoolClass: ["dataInsights"]
      },
      match: {params},
      select: {
        SchoolClass: ["id", "interpretedName", "schoolId"]
      }
    })

    this.dateFrom = useMemo(() => moment().subtract(4, "weeks").startOf("day").toDate(), [])
    this.dateTo = useMemo(() => moment(currentDate()).endOf("day").toDate(), [])
    this.queryParams = useQueryParams()
    this.schoolClass = schoolClass
    this.schoolClassId = schoolClassId
    this.schoolClassNotFound = schoolClassNotFound
    this.t = t


    useFrontLayout()?.setState({
      headerTitle: t(".insights_for_class", {class_name: schoolClass?.interpretedName()}),
      headerTitleCentered: true,
      menu: false,
      schoolClass,
      subHeader: this.subHeader(),
      topLeft: this.topLeft(),
      userMenu: false,
      weekBar: false
    })
  }

  render() {
    const {dateFrom, dateTo, schoolClass} = this.tt
    const activeSlide = this.activeSlide()

    if (activeSlide == 0) {
      this.setState({slide1loaded: true})
    } else if (activeSlide == 1) {
      this.setState({slide2loaded: true})
    } else if (activeSlide == 2) {
      this.setState({slide3loaded: true})
    }

    return (
      <View dataSet={this.rootViewDataSet ||= {route: "user--school-classes--insights"}}>
        <Slider active={activeSlide} onSlideChanged={this.tt.onSlideChanged} total={3}>
          <Slide active={activeSlide == 0}>
            {this.s.slide1loaded && schoolClass &&
              <MoodChartSlide dateFrom={dateFrom} dateTo={dateTo} schoolClass={schoolClass} />
            }
          </Slide>
          <Slide active={activeSlide == 1}>
            {this.s.slide2loaded && schoolClass &&
              <MoodBarChartSlide schoolClass={schoolClass} />
            }
          </Slide>
          <Slide active={activeSlide == 2}>
            {this.s.slide3loaded && schoolClass &&
              <ScoreFactorChartSlide dateFrom={dateFrom} dateTo={dateTo} schoolClass={schoolClass} />
            }
          </Slide>
        </Slider>
      </View>
    )
  }

  activeSlide = () => Number(this.tt.queryParams.slide || 0)
  onSlideChanged = ({number}) => Params.changeParams({slide: number})

  subHeader() {
    const {queryParams, t} = this.tt
    const activeSlide = this.activeSlide()

    if (activeSlide == 0) {
      return this.t(".sub_header")
    } else if (activeSlide == 1 && !queryParams.active_week) {
      return this.t(".sub_header_mood_bar_chart_slide_no_active_week")
    } else if (activeSlide == 1 && queryParams.active_week) {
      return this.t(".sub_header_mood_bar_chart_slide_active_week")
    } else if (activeSlide == 2) {
      const replaces = [
        {
          component: (
            <i className="fa fa-thumbs-up" key="thumbs-up" />
          ),
          text: "%{thumbs_up}"
        },
        {
          component: (
            <i className="fa fa-thumbs-down" key="thumbs-down" />
          ),
          text: "%{thumbs_down}"
        }
      ]

      return (
        <TextComponentReplace
          replaces={replaces}
          text={t(".sub_header_score_factor_chart_slide")}
        />
      )
    }
  }

  topLeft() {
    const {schoolClassId, t} = this.tt

    return (
      <BackLink to={Routes.userSchoolClassClassSpacePath(schoolClassId)}>
        {t(".back_link")}
      </BackLink>
    )
  }
}

export default memo(shapeComponent(RoutesUserSchoolClassesInsights))
